import { module } from 'angular';
import templateBuilderDisplayKid from './builder/display.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/kid/display.html', templateBuilderDisplayKid);
});
